import React from 'react';

import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeature, useFeatureWithAnalytics} from 'components/feature';
import {Price} from 'components/price/price';
import {RebateGrandTotal} from 'desktop/pages/checkout/components/rebateGrandTotal/rebateGrandTotal';
import {ApplicationStoreType} from 'desktop/store';

import {
    getCartTotalWithRebate,
    getTotalRebateSum,
} from '../../store/selectors/rebateDiscount/rebateDiscount';

import s from './cartSummaryGrandTotal.scss';

export type PropsType = {
    subtotal: number;
    total: number;
    totalRebateDiscount: number;
    totalWithRebate: number;
};

/**
 * Displays grand total for cart summary
 * @returns {CartSummaryGrandTotal} - component
 */
export const CartSummaryGrandTotal: React.FC<PropsType> = ({
    subtotal,
    total,
    totalRebateDiscount,
    totalWithRebate,
}) => {
    const isClRebate = useFeature('clRebate');
    const isDiscountColor = useFeatureWithAnalytics('dCartUI_discountColor', false, 'desktop');
    const hasDicount = subtotal > total;

    if (isClRebate && totalRebateDiscount) {
        return (
            <RebateGrandTotal
                className={s.rebateGrandTotal}
                eventName="cartFooter"
                price={total}
                title="Grand total"
                totalRebateDiscount={totalRebateDiscount}
                totalWithRebate={totalWithRebate}
            />
        );
    }

    return (
        <p className={s.priceTotal} data-test-name="cartSummaryTotal">
            <span className={s.total}>Grand total:</span>
            <span
                className={classNames({[s.totalUnderFlag]: isDiscountColor})}
                id="summary_grand_total"
            >
                {hasDicount && isDiscountColor && (
                    <span className={s.subtotalUnderFlag}>
                        <Price>{subtotal}</Price>
                    </span>
                )}
                &nbsp;
                <span className={classNames({[s.discounted]: hasDicount})}>
                    <Price>{total}</Price>
                </span>
            </span>
        </p>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    subtotal: Number(store.cart.totals.subtotal),
    total: Number(store.cart.totals.total),
    totalRebateDiscount: getTotalRebateSum(store),
    totalWithRebate: getCartTotalWithRebate(store),
});

export const CartSummaryGrandTotalConnected = connect(mapStateToProps)(CartSummaryGrandTotal);
